// Gemeinsame RBAC-Helfer fuer das Frontend
export const LEVELS = { none: 0, view: 1, edit: 2, delete: 3 };
export const LEVEL_ORDER = ["none", "view", "edit", "delete"];

export const LEVEL_LABELS = {
  de: { none: "Kein Zugriff", view: "Sehen", edit: "Bearbeiten", delete: "Löschen" },
  en: { none: "No access", view: "View", edit: "Edit", delete: "Delete" },
};

export const AREA_LABELS = {
  de: {
    uebersicht: "Übersicht / Geräte", standorte: "Standorte", tickets: "Tickets",
    lager: "Lager / Bestand", scanner: "Scanner", agent: "Agent-Skript",
    berichte: "Berichte", benutzer: "Benutzerverwaltung", remote: "Remote / TeamViewer", freigabe: "Retoure-Freigabe",
    standortantrag: "Neuer Standort (Antrag)",
  },
  en: {
    uebersicht: "Overview / Devices", standorte: "Locations", tickets: "Tickets",
    lager: "Stock", scanner: "Scanners", agent: "Agent script",
    berichte: "Reports", benutzer: "User management", remote: "Remote / TeamViewer", freigabe: "Return approval",
    standortantrag: "New location (request)",
  },
};

// user.perms = { area: level }
export function can(user, area, level = "view") {
  if (!user) return false;
  const have = LEVELS[(user.perms || {})[area] || "none"] || 0;
  return have >= (LEVELS[level] || 0);
}
